import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getNewStockReturnReasonHistory } from '../../../../../../Core/Service/workflowMovementHistory-service';
import moment from 'moment';

const HistoryTableRow = ({ item }) => {
    return (
        <tr className="row">
            <td className="time-type">{item.returnDate && moment(item.returnDate).format('LLL')}</td>
            <td className="name-type">{item.returnReason}</td>
            <td className="name-type">{item.returnedBy}</td>
            <td className="name-type">
                {item.currentWorkFlow} =&gt; {item.returnedWorkFlow}
            </td>
        </tr>
    );
};

const HistoryTable = ({ rec, loading }) => {
    return (
        <>
            <table className="movement-history-header">
                <thead>
                    <tr className="header">
                        <th className="time-type">Return Date</th>
                        <th className="name-type">Return Reason</th>
                        <th className="name-type">Returned By</th>
                        <th className="name-type">Workflow Movement</th>
                    </tr>
                </thead>
            </table>
            <div className="body-table-container custom-scroll">
                <table className="movement-history-body">
                    <tbody>
                        {rec.map((r, i) => (
                            <HistoryTableRow key={i} item={r} />
                        ))}
                        {rec.length === 0 && (
                            <tr>
                                <td colSpan="5">{loading ? 'Loading...' : 'No record found.'}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};
const ReturnReasonHistoryModal = (props) => {
    const [state, setState] = useState({
        loading: false,
        history: []
    });

    const handleClose = () => {
        props.onClose && props.onClose();
    };

    useEffect(() => {
        setState((st) => ({ ...st, loading: true }));
        getNewStockReturnReasonHistory(props.stockID, props.isNew)
            .then((res) => {
                if (res.success) {
                    setState((st) => ({ ...st, history: res.data?.returnReasons }));
                }
            })
            .finally(() => {
                setState((st) => ({ ...st, loading: false }));
            });
    }, [props.stockID]);

    return (
        <Dialog open={true} onClose={handleClose} maxWidth="md" className="dialog-custom workflow-movement-modal">
            <DialogTitle>
                Return Reason History
                <div className="title-header-actions">
                    <span className="close-icon" onClick={handleClose}>
                        &times;
                    </span>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="movement-history">
                    <HistoryTable rec={state.history} loading={state.loading} />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ReturnReasonHistoryModal;
